import React from "react";
import { toast } from "react-toastify";
import Toast from "../components/Toast";

import uniqBy from "lodash/uniqBy";
// import map from "lodash/map";
import without from "lodash/without";
// import each from "lodash/each";

const moment = require("moment");

export function getUnitOfMeasure(unit) {
  if (unit === "Percentage") {
    return "%";
  }
  return "";
}

export function reduceSupportedExtensions(list) {
  const array = [];
  list.map((item) => {
    return array.push(`.${item.Value}`);
  });
  return array;
}

export const measuresMonths = {
  annual: 12,
  monthly: 1,
  quarterly: 3,
  "semi-annual": 6,
};

export function cleanKPIMeasures(
  numberOfYears,
  startDate,
  frequency,
  measures
) {
  // const momentStart = moment(startDate).add(12, "months");
  const endDate = moment(startDate).locale("en").add(numberOfYears, "years");
  const diff = endDate.diff(startDate, "months");
  const months = measuresMonths[frequency.Value];
  const periods = diff / months;
  const arr = [];
  for (let i = 1; i <= periods; i++) {
    const DueDate = moment(startDate)
      .locale("en")
      .add(months * i, "months");
    arr.push({
      Target: "",
      DueDate: DueDate.format("MM-DD-YYYY"),
      Year: DueDate.year(),
      ItemIndex: i - 1,
      IsEditable: true,
      ...measures?.[i - 1],
    });
  }
  return arr;
}

export function newCleanKPIMeasures(
  initialStartDate,
  endDate,
  frequency,
  measures
) {
  const startDate = new Date(initialStartDate).setHours(0, 0, 0, 0);
  const diff = moment(endDate).diff(startDate, "months");
  const months = measuresMonths[frequency.Value];
  const periods = diff / months;
  const arr = [];

  for (let i = 0; i <= periods; i++) {
    let DueDate = moment(startDate)
      .locale("en")
      .add(months * i, "months");

    if (DueDate.day() === 5) DueDate = DueDate.locale("en").add(2, "days");
    else if (DueDate.day() === 6) DueDate = DueDate.locale("en").add(1, "days");

    arr.push({
      Target: "",
      DueDate: DueDate.locale("en").format("MM-DD-YYYY"),
      Year: DueDate.year(),
      ItemIndex: i,
      ...measures?.[i],
    });
  }

  return arr;
}

export function UnitOfMeasure(unit) {
  if (unit === "Percentage") {
    return "%";
  }
  return "";
}

export function getArraysValue(list, key) {
  const newList = [];
  list.map((item) => newList.push(`${item[key]}`));
  return newList;
}

export function getArrayLabelValue(list, locale) {
  const newList = [];
  list.map((item) =>
    newList.push(
      locale === "ar"
        ? getMonthNameAr(moment(new Date(item.DueDate)).month())
        : getMonthName(moment(new Date(item.DueDate)).month())
    )
  );
  return newList;
}

export function getArrayLabelValueYear(list, locale) {
  const newList = [];
  list.map((item) =>
    newList.push(moment(new Date(item.DueDate)).format("YYYY"))
  );
  return newList;
}

export function getArrayQuarter(list) {
  const newList = [];
  list.map((item) =>
    newList.push(
      "Q " +
        moment(new Date(item.DueDate)).utc().quarter() +
        " " +
        moment(new Date(item.DueDate)).format("YYYY")
    )
  );
  return newList;
}

export function getKPIYears(data) {
  moment.locale("en");
  const newList = [];
  data.map((item) => {
    const date = moment(new Date(item.DueDate)).format("YYYY");
    const obj = {
      value: date,
      label: date,
    };
    return newList.push(obj);
  });

  return uniqBy(newList, function (e) {
    return e.value;
  });
}

export function reduceUsersSelect(list) {
  const newList = [];
  list.map((item) => {
    const obj = {
      value: item.UserName,
      label: item.DisplayName,
    };
    newList.push(obj);
    return newList;
  });
  return newList;
}

export const Frequency = [
  {
    value: "Annual",
    label: "Annual",
  },
  {
    value: "Monthly",
    label: "Monthly",
  },
  {
    value: "Quarterly",
    label: "Quarterly",
  },
  {
    value: "Semi-Annual",
    label: "Semi-Annual",
  },
];

export const UnitOfMeasureList = [
  {
    value: "Percentage",
    label: "Percentage",
    labelAr: "نسبة مئوية",
  },
  {
    value: "Value",
    label: "Number",
    labelAr: "عدد",
  },
];

export const UnitOfMeasureForInitiative = [
  {
    value: "Percentage",
    label: "Percentage",
    labelAr: "نسبة مئوية",
  },
  {
    value: "Value",
    label: "Number",
    labelAr: "رقم",
  },
  {
    value: "MultipleChoice",
    label: "Multiple Choice",
    labelAr: "اختيار من متعدد",
  },
];

export const YesNoOptions = [
  {
    Value: true,
    EnglishName: "Yes",
    ArabicName: "نعم",
  },
  {
    Value: false,
    EnglishName: "No",
    ArabicName: "لا",
  },
];

export function reduceKPIType(list) {
  const newList = [];
  list.map((item) => {
    const obj = {
      value: item.Value,
      label: item.English,
    };
    newList.push(obj);
    return newList;
  });
  return newList;
}

export function formatDate(date) {
  if (date) {
    const newDate = moment(new Date(date)).add(0, "M").format("YYYY-MM-DD");
    return moment(newDate).add(0, "M").format("DD-MM-YYYY");
  }
}

export function cleanHandshakeData(data) {
  const cleanData = {};
  data.forEach((item) => {
    cleanData[item.Name] = {};
    if (item.Items) {
      item.Items.forEach((subItem) => {
        cleanData[item.Name][subItem.Value] = subItem;
      });
    }
  });

  return cleanData;
}

export function cleanHandshakeData1(data) {
  const cleanData = {};
  data.forEach((item) => {
    cleanData[item.Name] = { item };
  });
  return cleanData;
}
export function reduceHandShake(obj) {
  const FileTypesList = [];
  Object.values(obj.DocumentType).map((item) => {
    FileTypesList.push(`${item.Value}`);
  });
  const data = {
    file_types: FileTypesList,
    day_updated_no: parseInt(obj.Configuration.day_updated_no.English),
    files_default_size: parseInt(obj.Configuration.files_default_size.English),
    number_of_year: parseInt(obj.Configuration.number_of_year.English),
    primary: obj.Configuration.primary.Color,
    secondary: obj.Configuration.secondary.Color,
    required_updated_color: obj.Configuration.required_updated_color.Color,
    theme_header_background: obj.Configuration.theme_header_background.Color,
    pillar_header_background: obj.Configuration.pillar_header_background.Color,
    updated_color: obj.Configuration.updated_color.Color,
    ShowPortfolios: obj.Configuration.ShowPortfolios.Others === "true",
    ShowBenefits: obj.Configuration.ShowBenefits.Others === "true",
    ShowThemes: obj.Configuration.ShowThemes.Others === "true",
    ShowPillars: obj.Configuration.ShowPillars.Others === "true",
    Is2Dimension: obj.Configuration.Is2Dimension.Others === "true",
  };

  document.documentElement.style.setProperty("--primary-color", data.primary);
  document.documentElement.style.setProperty(
    "--secondary-color",
    data.secondary
  );
  return data;
}

export function getMonthName(index) {
  switch (index + 1) {
    case 1:
      return "Jan";
    case 2:
      return "Feb";
    case 3:
      return "Mar";
    case 4:
      return "Apr";
    case 5:
      return "May";
    case 6:
      return "June";
    case 7:
      return "July";
    case 8:
      return "Aug";
    case 9:
      return "Sep";
    case 10:
      return "Oct";
    case 11:
      return "Nov";
    case 12:
      return "Dec";
    default:
      return "Jan";
  }
}
export function getMonthNameAr(index) {
  switch (index + 1) {
    case 1:
      return "يناير";
    case 2:
      return "فبراير";
    case 3:
      return "مارس";
    case 4:
      return "أبريل";
    case 5:
      return "مايو";
    case 6:
      return "يونيو";
    case 7:
      return "يوليو";
    case 8:
      return "أغسطس";
    case 9:
      return "سبتمبر";
    case 10:
      return "أكتوبر";
    case 11:
      return "نوفمبر";
    case 12:
      return "ديسمبر";
    default:
      return "يناير";
  }
}

export function getKPITypeStatusColor(list, statusValue) {
  const item = list.find((_item) => _item.Code === statusValue);
  return item?.Color;
}

export function getKPITypeStatusName(list, statusValue, locale) {
  const item = list.find((_item) => _item.Code === statusValue);
  return locale === "ar" ? item?.ArabicName : item?.EnglishName;
}

export function findObjBYSource(listSource, source) {
  const so = listSource.find((item) => item.Value === source);
  return so || listSource[listSource.length - 1];
}

export function getStatusKPIName(listStatuses, statusValue, locale) {
  const item = listStatuses.find((_item) => _item.Value === statusValue);
  return locale === "ar" ? item?.Arabic : item?.English || "";
}

export function getPolarityName(polarityList = [], statusValue, locale) {
  const newList = polarityList.map((item) => {
    if (item.Value?.toString() === statusValue?.toString())
      return locale === "ar" ? item.Arabic : item.English;
  });
  const list = without(newList, undefined);

  return list.length > 0
    ? list
    : locale === "ar"
    ? polarityList[polarityList.length - 1].Arabic
    : polarityList[polarityList.length - 1].English;
}

export function findUnitLabel(value) {
  const unitList = UnitOfMeasureList.map((item) => {
    if (item.value === value) {
      return item;
    }
  });
  const newList = without(unitList, undefined);
  return newList[0];
}

export function equationValidator(equation) {
  if (!equation.length) {
    return false;
  }
  try {
    eval(equation.replace(/[A-Za-z][\w$]*(\.[\w$]+)?(\[\d+])?/g, "1"));
    return true;
  } catch (e) {
    return false;
  }
}

export function getSelectOption(invalid) {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      boxShadow: "none",
      "&:hover": { borderColor: "none" },
      border: `1px solid ${invalid ? "#c62828" : "#f2f2f2"}`,
    }),
  };
  return customStyles;
}

export const addToast = {
  success: (msg, values, options) =>
    toast.success(
      <Toast messageId={msg} values={values} type="success" />,
      options
    ),
  error: (msg, values, options) =>
    toast.error(
      <Toast messageId={msg} values={values} type="error" />,
      options
    ),
};

export function SearchTree(originData, searchedFilter) {
  let filterText = searchedFilter.trim().toLowerCase();
  let filterdList =
    filterText.length > 0
      ? originData.filter(
          (item) =>
            item.EnglishName.toLowerCase().includes(filterText) ||
            item.ArabicName.toLowerCase().includes(filterText)
        )
      : originData;
  return filterdList;
}

export function recursiveList(newData, originList) {
  let list = [];
  (function () {
    let recursive = function (data) {
      function SelectAll(data) {
        data.forEach(function (item) {
          if (item && item.ParentID > 0) {
            list.push(item);
            const newObj = originList.find((sub) => sub.ID === item.ParentID);
            SelectAll([newObj]);
          } else if (item.ParentID == null) {
            list.push(item);
          }
        });
      }
      SelectAll(data);
    };
    recursive(newData);
  })();
  return uniqBy(list, "ID");
}

export function recursiveParent(newData, originList) {
  let list = [];
  (function () {
    let recursive = function (data) {
      function SelectAll(data) {
        data.forEach(function (item) {
          list.push(item);
          const newObj = originList.filter((sub) => sub.ParentID === item.ID);
          SelectAll(newObj);
        });
      }
      SelectAll(data);
    };
    recursive(newData);
  })();
  return uniqBy(list, "ID");
}

export function getKPIsByCurrentUser(user, list, showKPIs, division) {
  const newList = list.filter((_item) =>
    division?.ID > 0 ? _item.OrgStructure?.ID === division?.ID : _item
  );
  const _list = newList.filter(
    (_item) =>
      _item.ChampionModel?.UserName === user.UserName ||
      _item.OwnerModel?.UserName === user.UserName ||
      _item.SponsorModel?.UserName === user.UserName
  );
  if (showKPIs) return _list;
  return newList;
}

export function chartsData(list = [], statuses = [], locale) {
  const colors = [];
  const labels = [];
  const values = [];
  const data = [];
  const kpis = [];

  statuses.forEach((item) => {
    colors.push(item.Color);
    labels.push(locale === "ar" ? item.ArabicName : item.EnglishName);
    values.push(item.Code);
    const temp = list.find((kpiItem) => kpiItem.Status === item.Code);
    data.push(temp?.KPICount);
    kpis.push(temp?.KPIs);
  });
  return {
    data,
    colors,
    labels,
    values,
    kpis,
  };
}

export function reverseStatusesList(statuses) {
  const _statuses = [...statuses];

  return _statuses.reverse();
}

export function getUserViewPermission(userSecurityInfo = [], viewGroup) {
  let isUserAllowed = false;

  if (typeof viewGroup === "string") {
    isUserAllowed = Boolean(
      userSecurityInfo.find((item) => item === viewGroup)
    );
  }

  if (Array.isArray(viewGroup)) {
    for (let i = 0; i < userSecurityInfo.length; i++) {
      if (viewGroup.find((group) => group === userSecurityInfo[i])) {
        isUserAllowed = true;
        break;
      }
    }
  }

  return isUserAllowed;
}

export function formatBytes(bytes, decimals = 2, locale) {
  const lang = locale === "en" ? 0 : 1;

  const sizes = [
    ["Bytes", "بايت"],
    ["KB", "كيلوبايت"],
    ["MB", "ميجابايت"],
    ["GB", "جيجابايت"],
    ["TB", "تيرابايت"],
    ["PB", "PB"],
    ["EB", "EB"],
    ["ZB", "ZB"],
    ["YB", "YB"],
  ];

  if (bytes === 0) return `0 ${sizes[0][lang]}`;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i][lang]}`;
}

export function sortByOrder(arr = []) {
  return arr.sort((a, b) => a.Order - b.Order);
}

export function hasAccess(groups, groupName) {
  const _groups = groups.map((item) => item?.Title);

  return _groups.includes(groupName);
}

export function getLookupName(listStatuses, statusValue, isAr) {
  const item = listStatuses?.find((_item) => _item?.Value === statusValue);

  return isAr ? item?.Arabic : item?.English || "";
}

export const monthDiff = (d1, d2) => {
  const date1 = new Date(d1);
  const date2 = new Date(d2);
  const diffTime = date2 - date1;

  const diffMonths = Math.floor(diffTime / (1000 * 3600 * 24 * 30));

  return diffMonths > 0 ? diffMonths : 0;
};

export function nFormatter(num, digits, isAr) {
  const si = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: isAr ? "ألف" : "K" },
    { value: 1e6, symbol: isAr ? "مليون" : "M" },
    { value: 1e9, symbol: isAr ? "مليار" : "B" },
    { value: 1e9, symbol: isAr ? "تريلون" : "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; ) {
    if (num >= si[i].value) {
      break;
    }
    i -= 1;
  }
  return `${(num / si[i].value).toFixed(digits).replace(rx, "$1")} ${
    si[i].symbol
  }`;
}

export const convertParseObjectsToMessages = (parseObjects, myID) => {
  const messages = [];
  parseObjects.forEach((parseObject) => {
    const senderID = parseObject.attributes.sender_id;
    const author = myID === senderID ? "me" : "them";
    const type = parseObject.attributes.type;
    const { creationDate, display_name } = parseObject.attributes;
    if (parseObject.attributes.type === "TEXT") {
      messages.push({
        author,
        senderID,
        type,
        displayName: display_name,
        creationDate: moment(creationDate).format("YYYY/MM/DD, h:mm A"),
        creationDateStamp: creationDate,
        data: { text: parseObject.attributes.body_text },
      });
    } else {
      messages.push({
        author,
        senderID,
        type,
        displayName: display_name,
        creationDate: moment(creationDate).format("YYYY/MM/DD, h:mm A"),
        creationDateStamp: creationDate,
        data: {
          url: parseObject.attributes.downloadUrl,
          fileName: `${parseObject.attributes.file_name}`,
        },
      });
    }
  });
  return messages;
};

export const getChatFileType = (attachment) => attachment.split(".").pop();

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
